"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
import { ShopifyExpertsBadge } from "@/components/common/BrandExpertsBadge";
import { shopifyWorkProjects, ShopifyWorkProject } from "./shopify.data";
const SOFT_SHADOW = "shadow-[0_3.4px_2.7px_-30px_rgba(0,0,0,0.06),0_8.2px_8.9px_-30px_rgba(0,0,0,0.07),0_25px_40px_-30px_rgba(0,0,0,0.2)]";
const HOVER_LIFT = "transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:-translate-y-[7.5px]";
interface ShopifyOurWorkProps {
  heading?: string;
  subtitle?: string;
  projects?: ShopifyWorkProject[];
  buttonText?: string;
  buttonHref?: string;
  className?: string;
}
export default function ShopifyOurWork(t0) {
  const $ = _c(53);
  const {
    heading: t1,
    subtitle: t2,
    projects: t3,
    buttonText: t4,
    buttonHref: t5,
    className: t6
  } = t0;
  const heading = t1 === undefined ? "View Our Work" : t1;
  const subtitle = t2 === undefined ? "Projects Delivered by our Developers!" : t2;
  const projects = t3 === undefined ? shopifyWorkProjects : t3;
  const buttonText = t4 === undefined ? "View All Projects" : t4;
  const buttonHref = t5 === undefined ? "/our-work" : t5;
  const className = t6 === undefined ? "" : t6;
  const desktopAnimations = useDesktopAnimations();
  const t7 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  let t9;
  if ($[1] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false;
    $[1] = desktopAnimations;
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  let t10;
  if ($[3] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t10;
  } else {
    t10 = $[4];
  }
  let t11;
  if ($[5] !== desktopAnimations) {
    t11 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  let t13;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      once: true
    };
    t13 = {
      duration: 0.7
    };
    $[7] = t12;
    $[8] = t13;
  } else {
    t12 = $[7];
    t13 = $[8];
  }
  let t14;
  if ($[9] !== heading) {
    t14 = <h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[9] = heading;
    $[10] = t14;
  } else {
    t14 = $[10];
  }
  let t15;
  if ($[11] !== subtitle) {
    t15 = subtitle && <p className="font-sans mt-2 text-[15px] font-normal text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p>;
    $[11] = subtitle;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  let t16;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t14 || $[16] !== t15 || $[17] !== t9) {
    t16 = <motion.div initial={t9} whileInView={t10} animate={t11} viewport={t12} transition={t13}>{t14}{t15}</motion.div>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t14;
    $[16] = t15;
    $[17] = t9;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== desktopAnimations) {
    t17 = desktopAnimations ? {
      opacity: 0,
      scale: 0.95
    } : false;
    $[19] = desktopAnimations;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== desktopAnimations) {
    t18 = desktopAnimations ? {
      opacity: 1,
      scale: 1
    } : undefined;
    $[21] = desktopAnimations;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== desktopAnimations) {
    t19 = desktopAnimations ? undefined : {
      opacity: 1,
      scale: 1
    };
    $[23] = desktopAnimations;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  let t21;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      once: true
    };
    t21 = {
      duration: 0.7,
      delay: 0.1
    };
    $[25] = t20;
    $[26] = t21;
  } else {
    t20 = $[25];
    t21 = $[26];
  }
  let t22;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <ShopifyExpertsBadge />;
    $[27] = t22;
  } else {
    t22 = $[27];
  }
  let t23;
  if ($[28] !== t17 || $[29] !== t18 || $[30] !== t19) {
    t23 = <motion.div initial={t17} whileInView={t18} animate={t19} viewport={t20} transition={t21} className="flex items-center gap-2.5 self-start sm:self-auto">{t22}</motion.div>;
    $[28] = t17;
    $[29] = t18;
    $[30] = t19;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== t16 || $[33] !== t23) {
    t24 = <div className="mb-12 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end md:mb-16">{t16}{t23}</div>;
    $[32] = t16;
    $[33] = t23;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  let t25;
  if ($[35] !== desktopAnimations || $[36] !== projects) {
    let t26;
    if ($[38] !== desktopAnimations) {
      t26 = (project, index) => {
        const isExternal = /^https?:\/\//.test(project.url || "");
        const card = <div className={HOVER_LIFT}><div className={`relative block w-full overflow-hidden rounded-lg bg-[#f3f9ff] ${SOFT_SHADOW} dark:bg-[#141414]`}><Image src={project.image} alt={project.alt || project.title} width={1372} height={914} loading="lazy" className="h-auto w-full object-contain" /></div><div className={`relative -top-10 mx-auto w-[95%] rounded-bl-lg rounded-br-lg rounded-tl-[40px] rounded-tr-lg bg-white p-[15px] text-center ${SOFT_SHADOW} dark:bg-[#181818]`}><h3 className="font-poppins text-lg font-semibold leading-9 text-[#050748] sm:text-[22px] sm:leading-10 dark:text-[#e6e6e6]">{project.title}</h3><p className="font-open-sans text-[15px] leading-7 text-[#6a6a8e] sm:text-[17px] dark:text-slate-400">Shopify Website</p></div></div>;
        return <motion.article key={project.id} initial={desktopAnimations ? {
          opacity: 0,
          y: 40
        } : false} whileInView={desktopAnimations ? {
          opacity: 1,
          y: 0
        } : undefined} animate={desktopAnimations ? undefined : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.7,
          delay: index % 2 * 0.12,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="group relative">{project.url ? isExternal ? <a href={project.url} target="_blank" rel="noopener noreferrer" className="block">{card}</a> : <Link href={project.url} className="block">{card}</Link> : card}</motion.article>;
      };
      $[38] = desktopAnimations;
      $[39] = t26;
    } else {
      t26 = $[39];
    }
    t25 = projects.map(t26);
    $[35] = desktopAnimations;
    $[36] = projects;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[40] !== t25) {
    t26 = <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-2">{t25}</div>;
    $[40] = t25;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== buttonHref || $[43] !== buttonText || $[44] !== desktopAnimations) {
    t27 = buttonText && <motion.div initial={desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: 0.25
    }} className="mt-14 flex justify-center text-center md:mt-18"><GradientButton href={buttonHref} variant="pink-purple" className=""><span>{buttonText}</span><FaChevronRight className="ml-1 text-[12px]" /></GradientButton></motion.div>;
    $[42] = buttonHref;
    $[43] = buttonText;
    $[44] = desktopAnimations;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] !== t24 || $[47] !== t26 || $[48] !== t27) {
    t28 = <div className="relative z-10 mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-8">{t24}{t26}{t27}</div>;
    $[46] = t24;
    $[47] = t26;
    $[48] = t27;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t28 || $[51] !== t7) {
    t29 = <section className={t7}>{t8}{t28}</section>;
    $[50] = t28;
    $[51] = t7;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  return t29;
}